export const WeatherIcons: { [key: string]: any } = {
  "01d": require("./Weather/01d.png"),
  "01n": require("./Weather/01n.png"),
  "02d": require("./Weather/02d.png"),
  "02n": require("./Weather/02n.png"),
  "03d": require("./Weather/03d.png"),
  "03n": require("./Weather/03n.png"),
  "04d": require("./Weather/04d.png"),
  "04n": require("./Weather/04n.png"),
  "09d": require("./Weather/09d.png"),
  "09n": require("./Weather/09n.png"),
  "10d": require("./Weather/10d.png"),
  "10n": require("./Weather/10n.png"),
  "11d": require("./Weather/11d.png"),
  "11n": require("./Weather/11n.png"),
  "13d": require("./Weather/13d.png"),
  "13n": require("./Weather/13n.png"),
  "50d": require("./Weather/50d.png"),
  "50n": require("./Weather/50n.png"),
}
